import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService, TokenService } from 'libs/core/src/public-api';

export const setPasswordGuard: CanActivateFn = () => {
  const router = inject(Router);
  const tokenService = inject(TokenService);
  const authService = inject(AuthService);

  if (!tokenService.isAuthenticated()) {
    return router.parseUrl('/auth/login');
  }
  if (!authService.mustSetPassword()) {
    return router.parseUrl('/');
  }
  return true;
};
